<template>
  <v-card style="min-width:650px;">
    <v-list class="branded-background">
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon color="white" class="padding-right">info</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title class="modal-title">
            <span class="text-white text-truncate-popover">Migration Notice</span>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-text v-if="primaryAccount === 'Learner'">
      <p>Your account has been migrated to WeVideo. You can still access your grades here. To complete new assignments, log into <a href="https://www.wevideo.com">https://www.wevideo.com</a> using the same credentials.</p>
    </v-card-text>
    <v-card-text v-else>
      <p>Your account was migrated to the new platform. You can still access learner data from here. We recommend exporting your data for your records.</p>

      <p>To access your content or to create new content, please log into <a href="https://www.wevideo.com">https://www.wevideo.com</a> with your same username and password.</p>

      <p>For more information, please check out <a href="https://support.wevideo.com/hc/en-us/articles/31483557108891-FAQs-about-migrating-PlayPosit-accounts">this article</a>.</p>

      <p>Reach out to <a href="mailto:support@wevideo.com">support@wevideo.com</a> if you have any questions.</p>
    </v-card-text>
    <v-card-actions class="row-right" style="height:56px">
      <v-btn class="branded-background text-white" @click="setDashModal(null)">Confirm</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'MigrationNotice',
  computed: {
    ...mapState([
      'primaryAccount',
    ]),
  },
  methods: {
    ...mapMutations([
      'setDashModal',
    ]),
  },
};
</script>
